import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { deleteMethod, get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  addData: {},
  sorted: [],
  PurchaseNotesTypes: [],
  publicNote: null,  // public token-based note
};

const slice = createSlice({
  name: 'PurchaseNotes',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET PurchaseNotesManagement
    getAllPurchaseNotesTypesSuccess(state, action) {
      state.PurchaseNotesTypes = action.payload.data;
    },
    // GET PurchaseNotesManagement
    getPurchaseNotesSuccess(state, action) {
      state.data = action.payload.data;
    },
    
    // GET PublicPurchaseNotesManagement
    getPurchaseNoteByTokenSuccess(state, action) {
      state.publicNote = action.payload.data;
    },

    addOrUpdatePurchaseNotes(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getAllPurchaseNotesTypes() {
  return async () => {
    try {
      const response = await get(`allPurchaseNotesTypes`);
      if (response.status) {
        dispatch(slice.actions.getAllPurchaseNotesTypesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getPurchaseNotes(filters = {}) {
  return async (dispatch) => {
    try {
      const query = new URLSearchParams(filters).toString();
      const url = query ? `PurchaseNotes?${query}` : 'PurchaseNotes';

      const response = await get(url);

      if (response.status) {
        dispatch(slice.actions.getPurchaseNotesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}



// ----------------------------------------------------------------------

export function uploadPurchaseNotesDocuments(body) {
  return async () => {
    try {
      const response = await post(`uploadPurchaseNotesDocuments`,body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePurchaseNotes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addPurchaseNotes(body) {
  return async () => {
    try {
      const response = await post(`PurchaseNotes`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePurchaseNotes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addSupplierOrder(body) {
  return async () => {
    try {
      const response = await post(`SupplierOrder`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePurchaseNotes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updatePurchaseNotes(body) {
  return async () => {
    try {
      const response = await put(`PurchaseNotes`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePurchaseNotes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updatePurchaseNotesPaymentNote(body) {
  return async () => {
    try {
      const response = await put(`updatePurchaseNotesPaymentNote`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePurchaseNotes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function deletePurchaseNotes(body) {
  return async () => {
    try {
      const response = await deleteMethod(`PurchaseNotes`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePurchaseNotes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function sendPurchaseNoteSMS(body) {
  return async () => {
    try {
      const response = await post(`PurchaseNotes/sendSMS`, body);

      if (response.status) {
        // We don't update table data, just trigger success
        dispatch(
          slice.actions.addOrUpdatePurchaseNotes({
            data: { smsSent: true },
          })
        );
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getPurchaseNoteByToken(token) {
  return async (dispatch) => {
    try {
      const response = await get(`PurchaseNotes/public/${token}`);

      if (response.status) {
        dispatch(slice.actions.getPurchaseNoteByTokenSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateSupplierInvoiceNumber(body) {
  return async () => {
    try {
      const response = await put(`updateSupplierInvoiceNumber`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePurchaseNotes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}



